import { render, staticRenderFns } from "./SelectTab.vue?vue&type=template&id=0c331a3c&scoped=true&"
import script from "./SelectTab.vue?vue&type=script&lang=js&"
export * from "./SelectTab.vue?vue&type=script&lang=js&"
import style0 from "./SelectTab.vue?vue&type=style&index=0&id=0c331a3c&prod&lang=stylus&scoped=true&"
import style1 from "./SelectTab.vue?vue&type=style&index=1&id=0c331a3c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c331a3c",
  null
  
)

export default component.exports